import { render, staticRenderFns } from "./ren-region-tree.vue?vue&type=template&id=2e5f89e8&"
import script from "./ren-region-tree.vue?vue&type=script&lang=js&"
export * from "./ren-region-tree.vue?vue&type=script&lang=js&"
import style0 from "./ren-region-tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports